<template>
  <div class="welcome">
    <transition appear name="nameDrop" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <div v-on:click="clickHandler" class="result-names" v-if="!quizStarting">
          <div class = 'welcome welcome-grid animate-circles'> 
            <img class='circle-size green animated slideOutDown slower' src="static/images/home/green_circle.png" alt='weclome animatebg'>
            <img class='circle-size red animated .delay-01s slideOutDown slower5'src="static/images/home/red_circle.png" alt='weclome animatebg'>
            <img class='circle-size white animated .delay-03s slideOutDown slower7'src="static/images/home/white_circle.png" alt='weclome animatebg'>
          </div>
          <div class = 'welcome welcome-grid'> 
             <img src="static/images/global/intro_bg.jpg" alt='weclome bg'>
          </div>
          <div class = 'welcome-top2 welcome-logo'>
              <img src="static/images/global/global_starbucksLogo.png" alt='welcome logo'>
              <br>COUNTDOWN TO
          </div>
           <div class = 'welcome-text welcome-grid'>
              <img class="copy_1 animated popIn" src="static/images/home/copy_n.png" alt='welcome new'>
              <img class="copy_2 animated popIn delay-01s" src="static/images/home/copy_e.png" alt='welcome new'>
              <img class="copy_3 animated popIn delay-03s" src="static/images/home/copy_w.png" alt='welcome new'>
          </div>
            <div class = 'welcome-bottom2 welcome-grid'>
              <img class="copy_4 animated popIn delay-04s" src="static/images/home/copy2_y.png" alt='welcome years'>
              <img class="copy_5 animated popIn delay-06s" src="static/images/home/copy2_e.png" alt='welcome years'>
              <img class="copy_6 animated popIn delay-08s" src="static/images/home/copy2_a.png" alt='welcome years'>
              <img class="copy_7 animated popIn delay-1s" src="static/images/home/copy2_r.png" alt='welcome years'>
              <img class="copy_8 animated popIn delay-103s" src="static/images/home/copy2_s.png" alt='welcome years'>
              <div class = 'welcome-logo enter-txt'>ENTER NOW</div>
          </div>
          <div class = 'welcome-bottom welcome-grid'>
               <div class="begin-button" v-if="!quizStarting">
        <img src="static/images/global/intro_bg_bottom.png" alt='weclome bg'>
      </div>
            
          </div>
      </div>
    </transition>
    <transition appear name="floorDrop" enter-active-class="" leave-active-class="animated slideOutDown">
      <div class="result-floor" v-if="!quizStarting">
      </div>
    </transition>
  </div>
</template>

<script>
/* eslint-disable */

import { eventBus } from '../EventBus';

export default {
  props: ['audioElement'],
  data() {
    return {
      show: true,
      quizStarting: false
    };
  },
  created () {
        /* this.fetchHandler(); */
       this.timer = setInterval(this.fetchHandler, 8000) //after 5 seconds call next frame
    },
  methods: {
    clickHandler() {
        console.log('test');
        clearInterval(this.timer)
        this.fetchHandler();
    },
    fetchHandler() {
      this.showWelcome = false;
      this.activateQuestion = true;
      this.quizStarting = true;
      eventBus.beginQuiz();
      // begins transitions out, which then will result in beginquiz handler below getting fired
    },
    cancelAutoUpdate () { clearInterval(this.timer) }
  },
  beforeDestroy () {
      clearInterval(this.timer)
    }
};
</script>

<style lang="scss">
$break-phone-s: only screen and (min-height: 450px) and (max-height: 667px); //iphone 6 below
$break-phone-m: only screen and (min-height: 668px) and (max-height: 700px); ; //pixel2, iphone7plus
$break-phone-l: only screen and (min-height: 701px) and (min-height: 900px); //pixel2 XL, iphoneX
$break-tablet: only screen and (min-height: 901px) and (max-height: 1024px); 

%img {
    position: absolute;
    left:0px;
    margin-top:auto;
    margin-bottom:auto;
    width:100%;
    height: auto;
    background-repeat: no-repeat;
    background-size: cover;
    background-position:bottom;
}


.welcome {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;

  .result-names {
    position: absolute;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    top: 0;
    z-index:5;

    font-family: 'SoDoSans-Bold';
    color: #908c66;
    font-size: 26px;
    line-height: 36px;

    display: grid;
    grid-template-rows: 18% 20% 17% 19% 26%;
     grid-gap: 5px;
    background-color:#1f3932;
    justify-items: center;

     grid-template-areas: 
    "header"
    "top-holder"
    "copy-holder"
    "bottom-holder"
    "footer";
  }

  .welcome-grid {
    height:100%;
    width:100%;
    /* overflow:hidden; */
    top:0px;
    position:absolute;
    z-index:1;
      img {
        @extend %img;
      }
  }

.welcome-logo {
    height:100%;
    width:100%;
    overflow:hidden;
    top:0px;
    position:absolute;
    z-index:3;
      img {
        width: 20%;
        height:auto;
        bottom:0px;
        display: inline-block;
      }
    font-family: 'SoDoSans-Bold';
    color:white;
    font-size:1.5rem;
  }

  .border-grid {
    box-sizing: border-box;
    border-bottom: 2px solid black;
  }

  .enter-txt{
    top:130px;
  }

  .welcome-top {
    grid-area: header;
  }

  .welcome-top2 {
    grid-area: top-holder;
  }

  .welcome-bottom2 {
    grid-area: bottom-holder;
    z-index:10;

    .copy_4{
      width: 17%;
      height:auto;
      display: inline-block;
      position:relative;
     /*  margin-right:10px; */
      top:15px;
    }

    .copy_5{
      width: 11%;
      height:auto;
      display: inline-block;
      position:relative;
     /*  margin-right:10px;*/
    }

    .copy_6{
      width: 19%;
      height:auto;
      display: inline-block;
      position:relative;
     /*  margin-right:10px; */
      top:15px;
    }

    .copy_7{
      width: 15%;
      height:auto;
      display: inline-block;
      position:relative;
     /*  margin-right:10px;
      top:15px; */
    }

    .copy_8{
      width: 14%;
      height:auto;
      display: inline-block;
      position:relative;
     /*  margin-right:10px;*/
      top:15px;
    }
  }

  .welcome-bottom {
    /* grid-area: footer; */


  .begin-button {
    position: absolute;
     height:100%;
    width:100%;

    z-index:15;
    img {
      width: 100%;
      height:auto;
      display: block;
      bottom:0px;

      display: inline-block;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
  }

.animate-circles{
  position:absolute;
  width:100%;
  height:100%;
  z-index:2;

  .circle-size{
    width: auto;
    height:20%;
    position:absolute;
  }

  .red{
      left:60%;
    }

  .green{
      left:-15%;
    }

  .white{
      left:25%;
    }
}

.welcome-text {
  grid-area: copy-holder;
  position:absolute;
  width:100%;
  height:100%;
  left:0px;
  top:0px;

  // Force hardware acceleration
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);

  z-index:10;

  .copy_1{
    width: 16%;
    height:auto;
    display: inline-block;
    position:relative;
    margin-right:5px;
    top:15px;
  }

  .copy_2{
    width: 12%;
    height:auto;
    display: inline-block;
    position:relative;
  }

  .copy_3{
    width: 25%;
    height:auto;
   display: inline-block;
   position:relative;
   margin-left:5px;
   top:20px;
  }

  .background {
    left: 0;
    bottom: 0;
    width:100%;
    height:100%;
    z-index:1;
    position:absolute;
    background-repeat: no-repeat;
    background-size: cover;
     img {
      @extend %img;
    }
  }

}

}// end .welcome
</style>


// WEBPACK FOOTER //
// src/components/WelcomePage.vue